<ng-container *ngIf="holding$ | async as holding">

  <ng-container *ngIf="(investingEntities$ | async) as investingEntities">
    <terra-lp-asset-filter class="entities-filter" [items]="investingEntities" (onFilter)="filter($event)" />
  </ng-container>


  <!-- Investment performance section -->
  <terra-holding-investment-performance [cumulativeProjectedPerformance]="holding.cumulativeProjectedPerformance"
                                        [holdingDiscriminator]="holding.discriminator" class="details-section" />
  <!-- Cash Flow Chart -->
  <ng-container *ngIf="cashFlowChartData$ | async">
    <terra-holding-cash-flow class="chart" *ngIf="(displayCashFlowChart$ | async) && cashFlowChartData" [data]="cashFlowChartData" />
  </ng-container>

  <div class="metrics">
    <!-- My Position -->
    <terra-holding-my-position-section *ngIf="!!holdingPosition && (displayMyPosition$ | async)"
                                       (toDisplay)="displayMyPosition$.next($event)" [holdingSecurityType]="holding.initialSecurityType"
                                       [displayIrr]="holding.displayIrr" [displayCashOnCash]="holding.displayCashOnCash"
                                       [displayEquityMultiple]="holding.displayEquityMultiple" [includeUnrealizedNav]="holding.includeUnrealizedNav"
                                       [position]="holdingPosition" [initialCurrency]="holding.initialCurrency" />
    <!-- Capital Information -->
    <terra-holding-capital-information *ngIf="displayCapitalInformation$ | async" (toDisplay)="displayCapitalInformation$.next($event)"
                                       [holding]="holding" />
    <!-- Asset Details-->
    <terra-asset-details-section *ngIf="holding.discriminator === HoldingDiscriminator.Asset && (displayAssetDetails$ | async)"
                                 (toDisplay)="displayAssetDetails$.next($event)" [asset]="holding" />
    <!-- Project Information -->
    <terra-holding-project-information *ngIf="displayProjectInformation$ | async" (toDisplay)="displayProjectInformation$.next($event)"
                                       [holding]="holding" />
    <!--  Spend To Date  -->
    <terra-asset-spend-to-date-section *ngIf="holding.discriminator === HoldingDiscriminator.Asset && holding.projectBudgetUpdated"
                                       [asset]="holding" />
  </div>

  <!-- Reports -->
  <terra-holding-reports [holdingDiscriminator]="holding.discriminator" [isScrolledToReport]="scrollToReport" [holding]="holding"></terra-holding-reports>

  <!-- Holdings (under this fund, or that the fund is invested in them) -->
  <mat-expansion-panel *ngIf="holding.discriminator === HoldingDiscriminator.Fund && !!holding.relatedHoldings?.length" [expanded]="holding.relatedHoldings?.length <= 3" class="assets mat-elevation-z0">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Assets/Funds ({{ (holding && holding.relatedHoldings ? holding.relatedHoldings.length : 0) | terraNumber }})
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="section-content asset-cards-container">
      <a class="unstyled" *ngFor="let relatedHolding of holding?.relatedHoldings" matRipple
         [routerLink]="getChildHoldingUrl(relatedHolding)" [queryParams]="{'origin': holding.id}">
        <ng-container [ngSwitch]="relatedHolding.discriminator">
          <terra-lp-holding-card *ngSwitchCase="HoldingDiscriminator.Asset" [holding]="relatedHolding" />
          <terra-lp-holding-card *ngSwitchCase="HoldingDiscriminator.Fund" [holding]="relatedHolding" />
        </ng-container>
      </a>
    </div>
  </mat-expansion-panel>
</ng-container>
